export const SEND_VIA_EMAIL = "email";
export const SEND_VIA_PHONE = "phone";

/**
 * Works out who the contract is being sent to and how to reach them.
 *
 * For somebody already on GigMi we only have their username, which is either
 * an email or a phone. For a new user the sender chooses the channel, and we
 * send only the field belonging to that channel — the counterparty's username
 * is derived from it server-side, so a value carried over from the other
 * channel would create an account nobody can sign in to.
 */
export const buildContactPayload = ({ gigmiUser, username, email, phone, sendVia }) => {
  if (gigmiUser) {
    const isEmailUsername = Boolean(username?.includes("@"));
    return {
      email: isEmailUsername ? username : null,
      phone: isEmailUsername ? null : username || null,
      send_via: isEmailUsername ? SEND_VIA_EMAIL : SEND_VIA_PHONE,
    };
  }

  if (sendVia === SEND_VIA_PHONE) {
    const digits = phone ? `+${phone.replace(/\D/g, "")}` : null;
    return { email: null, phone: digits, send_via: SEND_VIA_PHONE };
  }

  return {
    email: email?.trim()?.toLowerCase() || null,
    phone: null,
    send_via: SEND_VIA_EMAIL,
  };
};
